import React, { useState } from 'react';
import './BarChart.css';
import { OtherText, ParagraphText } from 'styling/Typography';
import { Flex } from 'styling/GlobalStyles';

export const BarChart = ({ data, height, showLabels, percentage }: IBarChart) => {
    const maxValue = Math.max(...data.map(d => d.value));
    const [hoveredBar, setHoveredBar] = useState(null);
    const gridLines = 5;
    // TODO: Graph goes to 100 when percentage
    return (
        <Flex column gap='10px' style={{ height: height ?? '100%' }}>
            <div className="chart-wrapper">
                <div className="y-axis">
                    {Array.from({ length: gridLines + 1 }).map((_, idx) => (
                        <OtherText key={idx} style={{ opacity: '0.5' }} >
                            {Math.round((maxValue / gridLines) * (gridLines - idx))}{percentage && '%'}
                        </OtherText>
                    ))}
                </div>

                <div className="chart-container" style={{ height: height ?? '100%' }}>
                    {data.map((item, idx) => {
                        const barHeight = (item.value / maxValue) * 100;
                        return (
                            <div
                                key={idx}
                                className={!item.color ? 'bar-wrapper bar-gradient' : 'bar-wrapper'}
                                onMouseEnter={() => setHoveredBar(idx)}
                                onMouseLeave={() => setHoveredBar(null)}
                                style={{
                                    height: `${barHeight}%`,
                                    backgroundColor: item.color ?? null
                                }}
                            >
                                {hoveredBar === idx && (
                                    <div className="tooltip">
                                        <span className="tooltip-name">{item.name}</span>
                                        <span className="tooltip-value">{item.value}</span>
                                    </div>
                                )}
                                <div
                                    className="bar"
                                    style={{
                                        height: `${barHeight}%`,
                                        backgroundColor: item.color ?? null
                                    }}
                                />
                            </div>
                        );
                    })}
                </div>



            </div>
            {showLabels && <div className='labels-container' >
                {data.map((l, i) => <ParagraphText key={i} >{l.name}</ParagraphText>)}
            </div>}
        </Flex>
    );
};

interface IBarChart {
    data: {
        value: number;
        name: string
        color?: string
    }[]
    height?: number
    showLabels?: boolean
    percentage?: boolean
}